export default __webpack_public_path__ + "static/testimonial-user-8-160a9392f10ee561f62312c6869e6b62.jpg";